import styled from '@emotion/native';
import { IconButton } from 'react-native-paper';

export const StyledIconButton = styled(IconButton)`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: white;
  border-radius: 15%;
  margin-left: ${({ hasMargin }) => (hasMargin ? '0px' : '16px')};
`;
